<template>
  <aside id="sidebar"
    class="fixed top-0 left-0 z-10 w-64 h-screen pt-20 transition-transform bg-fuchsia-950 border-r border-strong/90 -translate-x-full dark"
    aria-label="Sidebar" :class="uiStore.menushow ? ' -translate-x-full ' : '-translate-x-full lg:translate-x-0'
      ">
    <div class="flex flex-col justify-between h-full pl-3 pb-4 overflow-y-auto bg-fuchsia-950">
      <div class="sidebar">
        <ClientOnly>
          <ul class="space-y-2 font-medium" id="ulMenu">
            <li class="linkMenu" id="linkMenu-dashboard">
              <nuxt-link to="/" id="liMenuItem-dash"
                class="text-white hover:text-white flex justify-between items-center p-2 font-semibold group"
                data-drawer-hide="logo-sidebar">
                <div class="flex items-center">
                  <nuxt-icon name="odometer" class="text-[30px]" />
                  <span class="ml-3">Dashboard</span>
                </div>
              </nuxt-link>
            </li>

            <li class="linkMenu text-white" :id="`linkMenu-${item.title}`" :key="index" v-for="(item, index) in items">
              <nuxt-link :to="item.link" :id="`liMenuItem-${item.title}`"
                class="text-white hover:text-white flex items-center p-2 group" data-drawer-hide="logo-sidebar"
                v-if="app_isDeveloper === 'true' || item.ativo === 'true'">
                <NuxtIcon :name="item.icon" class="text-[25px]" filled />
                <span class="ml-3">{{ item.title }}</span>
              </nuxt-link>
            </li>

            <li v-if="app_isDeveloper === 'true'">
              <nuxt-link to="/testes" class="text-white hover:text-white flex items-center p-2 group"
                data-drawer-hide="logo-sidebar">
                <NuxtIcon name="test" class="text-[25px]" filled />
                <span class="ml-3">Teste {{ app_isDeveloper }}</span>
              </nuxt-link>
            </li>
          </ul>
        </ClientOnly>
      </div>
      <div class="adminMenu space-y-2">
        <div class="py-4 px-5 bg-gray-600 rounded-l-md" v-if="permissao == 'd' || permissao == 'a'">
          <nuxt-link to="/usuarios" class="flex items-center space-x-2">
            <nuxt-icon name="usuarios" class="text-[30px] text-white" />
            <span class="text-white font-semibold">Usuários</span>
          </nuxt-link>
        </div>

        <OOAdministracao v-if="permissao == 'd'" />
      </div>
    </div>
  </aside>
</template>

<script setup>
import { useUserStore } from "@/stores/usuario_store";
const userStore = useUserStore();

import { useUiStore } from "@/stores/ui.store";
const uiStore = useUiStore();

//Usado para vefiricar se o componente esta habilitado
//no arquivo de configuração
//Se etiver habilitado, o componente aparece no menu
const config = useRuntimeConfig();
const app_isDeveloper = config.public.app_isDeveloper;

const permissao = ref("");

onMounted(async () => {
  await useAPI
    .get(`/geral/gupv1/?or=admin`)
    .then(({ data, pending }) => {
      permissao.value = data.error;
    });
});

let items = [
  {
    title: "Artigos",
    referencia: "artigos",
    icon: "file_edit",
    link: "/artigos",
    ativo: config.public.componentes.artigos,
  },
  {
    title: "Banners",
    referencia: "banners",
    icon: "carroucel",
    link: "/banners",
    ativo: config.public.componentes.banners,
  },
  {
    title: "Classificados",
    referencia: "classificados",
    icon: "megaphone",
    link: "/classificados",
    ativo: config.public.componentes.classificados,
  },
  {
    title: "Galeria de Imagens",
    referencia: "galerias",
    icon: "gallery",
    link: "/galerias",
    ativo: config.public.componentes.galerias,
  },
  {
    title: "Videos",
    referencia: "videos",
    icon: "video",
    link: "/videos",
    ativo: config.public.componentes.videos,
  },
  {
    title: "Imóveis",
    referencia: "imoveis",
    icon: "imobiliaria",
    link: "/imoveis",
    ativo: config.public.componentes.imoveis,
  },
  {
    title: "OOLoja",
    referencia: "ooloja",
    icon: "ooloja",
    link: "/ooloja",
    ativo: config.public.componentes.ooloja,
  },
  // {
  //   title: "Revenda de Carros",
  //   referencia: "revendas",
  //   icon: "imobiliaria",
  //   link: "/revendas",
  //   ativo: config.public.componentes.revendas,
  // },
];
</script>

<style lang="scss" scoped>
.sidebar .router-link-active {
  @apply bg-white text-gray-800;
}
</style>
